module.exports = require("core-js-pure/features/symbol/iterator");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js/symbol/iterator.js
// module id = 424
// module chunks = 0 1